let sharedAudioContext = null;

export const initAudio = () => {
    try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return;
        if (!sharedAudioContext) {
            sharedAudioContext = new AudioContextClass();
        }
        if (sharedAudioContext.state === 'suspended') {
            sharedAudioContext.resume().catch((err) => {
                console.warn("Could not resume AudioContext:", err);
            });
        }
    } catch (e) {
        console.warn("Failed to initialize AudioContext:", e);
    }
};

export const playBeep = (frequency = 800, duration = 0.15, volume = 0.12) => {
    try {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return;

        // Initialize if not already done
        if (!sharedAudioContext) {
            sharedAudioContext = new AudioContextClass();
        }

        // Resume context if suspended
        if (sharedAudioContext.state === 'suspended') {
            sharedAudioContext.resume().catch(() => {});
        }

        const osc = sharedAudioContext.createOscillator();
        const gain = sharedAudioContext.createGain();

        osc.type = 'sine';
        osc.frequency.setValueAtTime(frequency, sharedAudioContext.currentTime);

        gain.gain.setValueAtTime(volume, sharedAudioContext.currentTime);
        // smooth fade out to prevent clicks
        gain.gain.exponentialRampToValueAtTime(0.0001, sharedAudioContext.currentTime + duration);

        osc.connect(gain);
        gain.connect(sharedAudioContext.destination);

        osc.start();
        osc.stop(sharedAudioContext.currentTime + duration);
    } catch (e) {
        console.warn("Play beep failed:", e);
    }
};

// Automatically try to resume the shared AudioContext on first user interaction anywhere
if (typeof window !== 'undefined') {
    const handleInteraction = () => {
        initAudio();
        // Remove listeners once successfully activated
        if (sharedAudioContext && sharedAudioContext.state === 'running') {
            window.removeEventListener('click', handleInteraction);
            window.removeEventListener('keydown', handleInteraction);
            window.removeEventListener('touchstart', handleInteraction);
        }
    };
    window.addEventListener('click', handleInteraction);
    window.addEventListener('keydown', handleInteraction, true);
    window.addEventListener('touchstart', handleInteraction);
}
